/** Reshape explicit aggregate cohorts for a grouped categorical chart. */
export function categorySeriesResult(result, definitions, allowedMetricIds) {
  if (!Array.isArray(definitions) || definitions.length === 0) return result
  const allowed = new Set(allowedMetricIds)
  const metrics = new Map((result?.metadata?.metrics || []).map((metric) => [metric.id, metric]))
  const categories = new Map()
  const series = new Map()
  let observed = false
  for (const definition of definitions) {
    if (!allowed.has(definition.metric_id) || !definition.category || !definition.label) continue
    const metric = metrics.get(definition.metric_id)
    if (!metric || metric.has_data === false) continue
    const value = result.metadata.range_totals?.[metric.value_key || metric.name || metric.id]
    if (!Number.isFinite(Number(value)) || value === null || value === undefined) continue
    const key = `category-series-${series.size}`
    if (!series.has(definition.label)) series.set(definition.label, { id: key, name: definition.label, value_key: key, type: metric.type || 'COUNT', aggregation_mode: 'latest', non_additive: true })
    if (!categories.has(definition.category)) categories.set(definition.category, new Map())
    const row = categories.get(definition.category)
    // A duplicate cohort is ambiguous; never add snapshots together silently.
    if (row.has(series.get(definition.label).value_key)) return { data: [], metadata: { ...result.metadata, category_series_error: 'Each category and series must map to one measure.' } }
    row.set(series.get(definition.label).value_key, Number(value))
    observed = true
  }
  return {
    data: observed ? [...categories].map(([category, values]) => Object.fromEntries([['label', category], ...values])) : [],
    metadata: { ...result?.metadata, metrics: [...series.values()], series: undefined, row_dimensions: undefined, category_series: true },
  }
}
